import { AppState } from '@rhg/libs/auth0';
import { QuestionChoices } from '@rhg/providers/standalone-results-values/types';

export type PostScreeningAppState = AppState & {
    gadScore: number;
    phqScore: number;
    selfHarmScore: number;
    answers: QuestionChoices;
    hasAcceptedChdpp: boolean;
};

export function isPostScreeningAppstate(
    state: AppState | PostScreeningAppState
): state is PostScreeningAppState {
    return 'gadScore' in state;
}
